import React, { useEffect, useState } from "react";
import MagnetCursor from "../components/MagnetCursor.jsx";
import ScrollToTop from "../components/ScrollToTop.jsx";
import Preloader from "../components/Preloader.jsx";
import HeaderArea from "../components/HomeFive/HeaderArea.jsx";
import HeroSection from "../components/HomeFive/HeroSection.jsx";
import AboutSection from "../components/HomeFive/AboutSection.jsx";
import ServiceSection from "../components/HomeFive/ServiceSection.jsx";
import CaseStudyThree from "../components/HomeFive/CaseStudyThree.jsx";
import CountDownSection from "../components/HomeFive/CountDownSection.jsx";
import AwardsAndHonors from "../components/HomeFive/AwardsAndHonors.jsx";
import TestimonialSection from "../components/HomeFive/TestimonialSection.jsx";
import PricingPlan from "../components/HomeFive/PricingPlan.jsx";
import BlogWapper from "../components/HomeFive/BlogWapper.jsx";

function HomeFive() {
  //preloader
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  return (
    <div className="theme-two">
      {/* Preloader */}
      <Preloader />

      {/* Search Form */}
      <div className="search-bg-overlay" id="searchOverlay"></div>
      <div className="search-form-popup">
        <h2 className="mb-4">How can I help you, Today?</h2>
        <button
          type="button"
          className="close-btn"
          id="searchClose"
          aria-label="Close"
        >
          &times;
        </button>
        <form className="search-form">
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            id="site-search"
            name="q"
          />
          <button type="submit" className="btn btn-primary">
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
          </button>
        </form>
      </div>

      {/* Header Area*/}
      <HeaderArea />

      {/* Hero Section */}
      <HeroSection />

      {/* Popup Video Container */}
      <div id="videoPopup" className="video-popup-iframe">
        <div className="video-content">
          <span className="close-btn" id="videoCloseButton">
            &times;
          </span>
          <div className="ratio ratio-16x9">
            <iframe
              id="videoFrame"
              allowFullScreen
              title="YouTube video player"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Catagory Slide */}
      <div className="catagory-slide" id="catagorySlide">
        <div className="marquee3k" data-speed="1">
          <div>
            <div className="d-flex align-items-center mb-0">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_2980)">
                    <path
                      d="M19.2 12.8L16 0L12.8 12.8L0 16L12.8 19.2L16 32L19.2 19.2L32 16L19.2 12.8Z"
                      fill="#161D27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_2980">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Get Appointment</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_29810)">
                    <path
                      d="M19.2 12.8L16 0L12.8 12.8L0 16L12.8 19.2L16 32L19.2 19.2L32 16L19.2 12.8Z"
                      fill="#161D27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_29810">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Contact Us</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_29820)">
                    <path
                      d="M19.2 12.8L16 0L12.8 12.8L0 16L12.8 19.2L16 32L19.2 19.2L32 16L19.2 12.8Z"
                      fill="#161D27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_29820">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Get Appointment</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_29830)">
                    <path
                      d="M19.2 12.8L16 0L12.8 12.8L0 16L12.8 19.2L16 32L19.2 19.2L32 16L19.2 12.8Z"
                      fill="#161D27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_29830">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Contact Us</span>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <AboutSection />

      {/* Service Section */}
      <ServiceSection />

      {/* Case Study Three */}
      <CaseStudyThree />

      {/* Countdown Section */}
      <CountDownSection />

      {/* Pricing Plan */}
      <PricingPlan />

      {/* Testimonial Section */}
      <TestimonialSection />

      {/* Awards & Honors */}
      <AwardsAndHonors />

      {/* Blog Wrapper */}
      <BlogWapper />

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default HomeFive;
